<script>
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Slider from '../../States/Slider';

	export let index;

	let element = {};
	let properties = {};
	let active = false;

	function toPericope(name) {
		const base = jQuery(element);
		const selector = `h2[data-anchor="${name}"]`;
		const target = base.find(selector);
		if (target.length) {
			const head = 25;
			const top = target.offset().top - base.offset().top + base.scrollTop() - head;
			base.animate({scrollTop: top}, 1000 * .5);
		}
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'info', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			Helper.title('Info & Contact');
		}
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	p.plain {
		font-size: 1.25em;
		line-height: 1.5em;
		color: var(--secondary-color);
	}

	h2 {
		color: var(--primary-color) !important;
		margin-top: 2em;
		margin-bottom: 1em;
	}

	div.constraint {
		max-width: 45em;
	}

	p a {
		font-weight: bold;
		color: var(--secondary-color);
	}

	a.button {
		text-align: left;
	}

	/* Pericopes */

	div.pericopes.list {
		color: var(--secondary-color);
	}

	div.pericopes.list > .item {
		border-bottom: 2px solid var(--tertiary-background-light);
	}

	div.pericopes.list > .item > div {
		line-height: 1.5em;
	}

	div.pericopes.list div.name {
		margin-right: 1em;
	}

	div.pericopes.list div.name i {
		margin-right: 1em;
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Info &amp; Contact</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content" bind:this="{element}">
		<div class="constraint">
			{#if !$Data.version.beta}
				<div class="list pericopes">
					<div class="item" on:click="{event => toPericope('about')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Over de BasisBijbel
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('buy')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> BasisBijbel kopen
						</div>
					</div>
					{#if !Helper.app()}
						<div class="item" on:click="{event => toPericope('support')}">
							<i class="fad fa-arrow-down"></i>
							<div class="name">
								<i class="fad fa-align-left"></i> Steun de BasisBijbel
							</div>
						</div>
					{/if}
					<div class="item" on:click="{event => toPericope('contact')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Contact
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('copyright')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Copyright
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('delete')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Account verwijderen
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('privacy')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Privacy beleid
						</div>
					</div>
				</div>
				<h2 data-anchor="about">Over de BasisBijbel</h2>
				<p>Kenmerk van de BasisBijbel is de eenvoudige taal. Hij is voor iedereen die de Bijbel liever wat makkelijker heeft. Daarmee is hij ook heel geschikt voor beginnende bijbellezers. De tekst is gebaseerd op de Statenvertaling en is dus niet vertaald uit de oorspronkelijke talen.</p>
				<p>Echte bijbelwoorden (zoals tabernakel, zondvloed) zijn vervangen door gewonere woorden (grote overstroming, tent). Woorden en zinnen zijn kort gehouden. Hier en daar is tekst toegevoegd om een vers duidelijker te maken. Deze woorden zijn weergegeven in grijs. Ook wordt in aantekeningen verwezen naar andere bijbelgedeelten. Zo worden verzen of gebeurtenissen duidelijker.</p>
				<p>De BasisBijbel verscheen in 2013 als website. In 2016 werd hij  uitgegeven door Stichting ZakBijbelBond.</p>

				<h2 data-anchor="buy">BasisBijbel kopen</h2>
				<p>Er zijn verschillende uitvoeringen van de BasisBijbel. Deze zijn te koop bij de christelijke boekhandel en te bestellen bij onze uitgever, Stichting ZakBijbelBond. Dus NIET bij Stichting BasisBijbel.</p>
				<a class="button" href="https://www.zakbijbelbond.nl/nl/bijbel-kopen/basisbijbel-kopen/" target="_blank">
					<i class="fad fa-bible"></i> BasisBijbel kopen
				</a>

				{#if !Helper.app()}
					<h2 data-anchor="support">Steun de BasisBijbel</h2>
					<p>Ben je blij met de BasisBijbel? Je kunt het werk van Stichting BasisBijbel steunen met een gift op bankrekening: <strong>NL89 SNSB 0871 2859 24</strong></p>
				{/if}

				<h2 data-anchor="contact">Contact</h2>
				<p>Heb je vragen of opmerkingen? Stuur ons dan een e-mail via de onderstaande knop.</p>
				<a class="button" href="mailto:info@basisbijbel.nl" target="_blank">
					<i class="fad fa-envelope"></i> info@basisbijbel.nl
				</a>

				<h2 data-anchor="copyright">Copyright</h2>
				<p>Het copyright berust bij Stichting BasisBijbel. Tekst uit de BasisBijbel mag niet op enige wijze gekopieerd, verspreid en doorgegeven worden, in gedrukte vorm, digitaal of anderszins, behalve onder onze voorwaarden.</p>
				<a class="button" href="https://stichtingbasisbijbel.nl/voorwaarden" target="_blank">
					<i class="fad fa-balance-scale"></i> Klik hier voor de voorwaarden
				</a>

				<h2 data-anchor="delete">Account verwijderen</h2>
				<p>Wil je je account verwijderen? Zorg eerst dat je ingelogd staat. Klik daarna in het menu op je naam en volg de aanwijzingen. Al je gegevens en aantekeningen worden dan definitief gewist.</p>

				<h2 data-anchor="privacy">Privacy beleid</h2>
				<p>Wij gaan zorgvuldig om met je persoonlijke gegevens, om je privacy te beschermen. Op de onderstaande pagina vertellen we welke gegevens we verzamelen als je onze website gebruikt, waarom we deze gegevens verzamelen en wat we ermee doen.</p>
				<a class="button" href="/privacy">
					<i class="fad fa-file-contract"></i> Privacy beleid
				</a>
			{:else}
				<p>Deze website is nog in ontwikkeling en ook aan de tekst van de bijbelvertaling wordt nog volop gewerkt.</p>
			{/if}
		</div>
	</div>
</div>